/** MCC ITI list + add modal helpers */

export const ITI_TABLE_COLUMNS = [
  { header: "ITI NAME", accessor: "iti_name" },
  { header: "DISTRICT", accessor: "district" },
  { header: "USERNAME", accessor: "username" },
  { header: "PASSWORD", accessor: "password" },
];

export const emptyItiAddForm = () => ({
  district: "",
  itiname: "",
  tradename: [],
});

export const emptyItiEditForm = () => ({
  id: "",
  district: "",
  itiname: "",
  username: "",
  password: "",
  tradename: [],
});

/**
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export const validateItiAddForm = (form) => {
  if (!form.district?.trim()) {
    return { ok: false, message: "District is required" };
  }
  if (!form.itiname?.trim()) {
    return { ok: false, message: "ITI name is required" };
  }
  if (!Array.isArray(form.tradename) || form.tradename.length === 0) {
    return { ok: false, message: "At least one trade is required" };
  }
  return { ok: true };
};

/** Body for POST /v1/api/mcc/itis (credentials are generated on the server). */
export const buildAddItiPayload = (form) => ({
  district: form.district.trim(),
  iti_name: form.itiname.trim(),
  trade_ids: form.tradename.map((id) => Number(id)),
});

/** Body for PUT /v1/api/mcc/itis/:id (optional password: omit or empty keeps existing password). */
export const buildUpdateItiPayload = (form) => ({
  district: form.district.trim(),
  iti_name: form.itiname.trim(),
  trade_ids: form.tradename.map((id) => Number(id)),
  password: String(form.password ?? ""),
});

export const mapItiDetailToForm = (detail) => ({
  id: String(detail?.id ?? ""),
  district: String(detail?.district ?? ""),
  itiname: String(detail?.iti_name ?? ""),
  username: String(detail?.username ?? ""),
  password: String(detail?.password ?? ""),
  tradename: Array.isArray(detail?.trade_ids)
    ? detail.trade_ids.map((id) => String(id))
    : [],
});
